export function useTheme() {
  return { systemTheme: 'dark', theme: 'dark' };
}
